<template>
	<Table
		:pgLimitGet="pgLimit"
		backendDirectory="usuario/grupo/listar"
		:busca="{
            busca: busca.busca || null
        }"
		:filter="true"
		:keydown="keydown"
		:headers="{
            idgrupo: {nome: 'ID', tipo: permissao('grupo_get') ? 'link' : 'texto', link: '/usuario/grupo/get/', class: 'width'},
            grupo: {nome: 'Grupo', tipo: 'texto'},
        }"
	>
		<v-col>
			<v-text-field
				v-model="busca.busca"
				label="Buscar"
				outlined
				dense
				@keydown.enter="keydown = !keydown"
			/>
		</v-col>
	</Table>
</template>

<script>
import { mapState } from "vuex";
import Table from "../Widgets/Table";

export default {
	name: "UsuarioGrupoLista",
	components: { Table },
	data: () => ({
		busca: {},
		keydown: false,
	}),
	computed: {
		...mapState(["pgLimit"]),
	},
};
</script>

<style scoped>
</style>